// extracted by mini-css-extract-plugin
export var cardLayout = "_5v-1";
export var paginationContainer = "_5v-0";